function autoResize(ref, current, last) {
    const element = ref.current

    if (element) {
        if (current < last) {
            element.style.height = "auto"
            element.style.height = element.scrollHeight + "px"
        } else {
            requestAnimationFrame(() => {
                element.scrollTop = 0
                element.style.height = element.scrollHeight + "px"
            })
        }
    }
}

export default autoResize